<template>
  <div class="container">
    <table class="table table-striped">
      <thead class="thead-dark">
        <tr>
          <th>Név</th>
          <th>Email</th>
          <th>Vendégek száma</th>
          <th>Erre a részre jönne</th>
          <th>Megjegyzés</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="rsvp in list" :key="rsvp.rsvpId">
          <td>
            {{rsvp.rsvpName}}
          </td>
          <td>
            {{rsvp.rsvpEmail}}
          </td>
          <td>
            {{rsvp.rsvpGuests}}
          </td>
          <td>
            <template v-if="rsvp.rsvpEvent === '1'">
              Egyházi ceremónia
            </template>
            <template v-else-if="rsvp.rsvpEvent === '2'">
              Vacsora & Party
            </template>
            <template v-else-if="rsvp.rsvpEvent === '3'">
              Mindkettő
            </template>
          </td>
          <td>
            {{rsvp.rsvpComment}}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'list',
  data () {
    return {
      list: []
    }
  },
  created () {
    fetch('https://q4xk8cg9d0.execute-api.eu-central-1.amazonaws.com/dev/rsvps', {
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json; charset=UTF-8'
      }
    })
      .then((res) => res.json())
      .then((result) => {
        this.list = result
      })
  }
}
</script>
